module.exports = __webpack_public_path__ + "img/51.159be7c9.jpg";